import Model from '@/models/Model.js';

export default class AcknowledgeInformationActivity extends Model {
    static entity = 'acknowledge_information_activities';

    static modelName = 'AcknowledgeInformationActivity';

    static fields() {
        return {
            content_template_id: this.attr(null),
            content: this.attr(null),

            ...super.fields(),

            content_template: this.belongsTo('acknowledge_information_activity_templates', 'content_template_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
